export default function SentryFallback({ error }) {
  return (
    <div>
      {error?.message || 'An error has occured'}
    </div>
  )
}

